import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../../constants'
import CreationToolOutputType from '../../../../types/output-type'
import { StickerBlock } from '../../../blocks'
import { CreationToolUploadSource } from '../../types'

const Container = styled(StickerBlock)`
    align-items: center;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    display: flex;
    flex-shrink: 0;
    height: 100%;
    margin-right: 8px;
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: 50px;

    svg {
        display: block;
        height: 26px;
        position: relative;
        width: auto;
    }

    canvas {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
`

const Gradient = styled.div`
    background: radial-gradient(circle, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 100%);
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    source: CreationToolUploadSource
}

const CreationUploadItemIcon = ({ source: uploadSource }: Props) => {
    const previewRef = useRef<HTMLCanvasElement>(null)
    const { outputType, source } = uploadSource
    const Icon = CreationToolOutputType.icon(outputType)

    useEffect(() => {
        if (!previewRef.current || !source.preview) return

        const preview = source.preview
        const canvas = previewRef.current
        const context = canvas.getContext('2d')

        canvas.width = Math.min(preview.width, preview.height)
        canvas.height = canvas.width
        context?.drawImage(preview, -(preview.width - canvas.width) / 2, -(preview.height - canvas.height) / 2)
    }, [previewRef, source])

    return (
        <Container>
            <canvas ref={previewRef} />
            <Gradient />
            <Icon />
        </Container>
    )
}

export default CreationUploadItemIcon
